/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Dashboard
import Home from "./components/Dashboard/Home";
import Telecaller from "./components/Dashboard/Telecaller";
import Receptionist from "./components/Dashboard/Receptionist";
import Doctor from "./components/Dashboard/Doctor";
import Counsellor from "./components/Dashboard/Counsellor";
import ServiceCaller from "./components/Dashboard/ServiceCaller";
import Medical from "./components/Dashboard/Medical";
import ViewDetails from "./components/Dashboard/ViewDetails";
import PageReview from "./components/Dashboard/PageReview";
import AppForgetPassword from "./components/AppsMenu/AppProfile/AppForgetPassword";
import CasePaper from "./components/AppsMenu/AppProfile/CasePaper";

/// App
import Leads from "./components/AppsMenu/Patients/Leads";
import MonthlyTarget from "./components/AppsMenu/Patients/MonthlyTarget"
import ViewLead from "./components/AppsMenu/Patients/ViewLead";
import AddLeads from "./components/AppsMenu/Patients/AddLead";
import Patients from "./components/AppsMenu/Patients/Patients";
import ViewPatient from "./components/AppsMenu/Patients/ViewPatient";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import AddPatients from "./components/AppsMenu/Patients/AddPatients";
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import ImportLeads from "./components/AppsMenu/Patients/ImportLeads";

// Questionnaire
import Questions from "./components/Questions/Questions";
import Question from "./components/Questions/AddQuestion";
import Form from "./components/Questions/Forms";
import AddForm from "./components/Questions/AddForm";
import PatientForm from "./components/Questions/PatientForm";

// User
import Role from "./components/Users/Role";
import AddRole from "./components/Users/AddRole";
import User from "./components/Users/Users";
import AddUser from "./components/Users/AddUser";
//settings
import SiteSetting from "./components/Settings/SiteSetting";
import PatientReviewList from "./components/Settings/Review";
import GSTList from "./components/Settings/GST";
import AddGST from "./components/Settings/AddGST";
// Master

import Branch from "./components/Master/Branch";
// import Addbranch from "./components/Master/AddBranch";
import Medicine from "./components/Master/Medicine";
import AddMedicine from "./components/Master/AddMedicine";
import Department from "./components/Master/Department";
import Categories from "./components/Master/Categories";
import AddBranch from "./components/Master/AddBranch";
import Symptoms from "./components/Master/Symptoms";
import AddSymptom from "./components/Master/AddSymptom";
import Diseases from "./components/Master/Diseases";
import AddCategories from "./components/Master/AddCategories";
import AddDiseases from "./components/Master/AddDiseases";
import Doctors from "./components/Master/Doctors";
import AddDoctor from "./components/Master/AddDoctor";
import DoctorAvailability from "./components/Master/DoctorAvailability";
import MedicineMapping from "./components/Master/MedicineMapping";
import AddMedicineMapping from "./components/Master/AddMedicineMapping";
import SymptomMedicineMapping from "./components/Master/SymptomMedicineMapping";
import AddSymptomMedicineMapping from "./components/Master/AddSymptomMedicineMapping";
import AddPrescription from "./components/Master/AddPrescription";
import ContentBank from "./components/Master/ContentBank";
import AddContentBank from "./components/Master/AddContentBank";
import Script from "./components/Master/Script";
import AddScript from "./components/Master/AddScript";
import Objection from "./components/Master/Objection";
import AddObjection from "./components/Master/AddObjection";
import NoteCategories from "./components/Master/NoteCategories";
import AddNoteCategories from "./components/Master/AddNoteCategories";
import AddDefaultDose from "./components/Master/AddDefaultDose";
import DefaultDose from "./components/Master/DefaultDose";
import AssignedHistory from "./components/AppsMenu/Patients/AssignedHistory"
/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import EcomCustomers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import RechartJs from "./components/charts/rechart";
import ChartJs from "./components/charts/Chartjs";
import SparklineChart from "./components/charts/Sparkline";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
// import JqvMap from './components/PluginsMenu/JqvMap/JqvMap'
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

/// Widget
import Widget from "./pages/Widget";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Todo from "./pages/Todo";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import ChangePassword from "./components/AppsMenu/AppProfile/AppChangePassword";
import PatientsDetails from "./components/AppsMenu/Patients/PatientsDetails";
import Questionnaire from "./components/AppsMenu/Patients/Questionnaire";
import Patientprofile from "./components/Dashboard/Patientprofile";
import AddDepartment from "./components/Master/AddDepartment";
import TokenSystem from "./components/AppsMenu/AppProfile/TokenSystem";
import TokenSystemMulti from "./components/AppsMenu/AppProfile/TokenSystemMulti";
import RegisterYourSelf from "./components/AppsMenu/AppProfile/RegisterYourSelf";

//patients Components
import { PatientNotes } from "./components/AppsMenu/Patients/Components/Notes.components";
import AddNotes from "./components/AppsMenu/Patients/Components/AddNotes.Component";

import DiseaseHistory from "./components/AppsMenu/Patients/Components/DiseaseHistory";
import AppointmentCalendarTest from "./components/Common/AppointmentCalendarTest";
import WeightChart from "./components/AppsMenu/Patients/Components/WeightChart";
import OTPVerificationPage from "./components/Questions/OTPVerificationPage";
import PatientFormWrapper from "./components/Questions/PatientFormWrapper";
import { resetMenu } from "../store/actions/AuthActions";
import MenopauseFormPage from "./components/AppsMenu/Patients/Components/MenopauseFormPage";
import GapldFormPage from "./components/AppsMenu/Patients/Components/GapldFormPage";
import MaleFormPage from "./components/AppsMenu/Patients/Components/MaleFormPage";
// Panchkarma
import Niyamavali from "./components/Master/Niyamavali";
import AddNiyamavali from "./components/Master/AddNiyamavali";
import Karma from "./components/Panchkarma/Karma";
import AddKarma from "./components/Panchkarma/AddKarma";
import PanchkarmaUsers from "./components/Panchkarma/PanchkarmaUsers";
import AddPanchkarmaUser from "./components/Panchkarma/AddPanchkarmaUser";
import PanchkarmaServiceCaller from "./components/Panchkarma/ServiceCallerPanchkarma";
import PanchkarmaViewDetails from "./components/Panchkarma/ViewDetailsPanchkarma";
import Patient from "./components/Panchkarma/PanchkarmaPatients";
import DashboardPanchkarma from "./components/Panchkarma/DashboardPanchkarma";
import Therapist from "./components/Panchkarma/Components/Therapist";
import { components } from "react-select";
// import Karma from "./components/Panchkarma/Karma";
// import AddKarma from "./components/Panchkarma/AddKarma";
import AssignedAppointment from "./components/Dashboard/AssignedAppointment";
import Pathyas from "./components/Master/Pathyas";
import AddPathyas from "./components/Master/AddPathyas";
import OTPVerification from "./components/Dashboard/OTPVerification";
import UnitOfDose from "./components/Master/UnitOfDose";
import AddUnitOfDose from "./components/Master/AddUnitOfDose";
import Anupan from "./components/Master/Anupan";
import AddAnupan from "./components/Master/AddAnupan";
import HowToTake from "./components/Master/HowToTake";
import AddHowToTake from "./components/Master/AddHowToTake";
import Frequency from "./components/Master/Frequency";
import AddFrequency from "./components/Master/AddFrequency";
import Campaign from "./components/Master/Campaign";
import AddCampaign from "./components/Master/AddCampaign";
import ServiceCallerReassignment from "./components/AppsMenu/Patients/ServiceCallerReassignment";
import PrintQr from "./components/StockManagement/PrintQr";
import AddPrintQR from "./components/StockManagement/AddPrintQr"
import StockTransactions from "./components/StockManagement/StockTransactions";
import AddInwardStock from "./components/StockManagement/AddInwardStock";

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: "", component: <Home /> },
    { url: "dashboard", component: <Home /> },
    { url: "telecaller", component: <Telecaller /> },
    { url: "receptionist", component: <Receptionist /> },
    { url: "doctor", component: <Doctor /> },
    { url: "counsellor", component: <Counsellor /> },
    { url: "service-caller", component: <ServiceCaller /> },
    { url: "view-details", component: <ViewDetails /> },
    { url: "medical", component: <Medical /> },
    { url: "reviews", component: <PageReview /> },
    { url: "patient-profile", component: <Patientprofile /> },

    { url: "patients-notes", component: <PatientNotes /> },
    { url: "add-notes", component: <AddNotes /> },

    { url: "patients-disease-history", component: <DiseaseHistory /> },
    /// Apps (patients)
    { url: "app-leads", component: <Leads /> },
    { url: "monthly-target", component: <MonthlyTarget /> },
    { url: "app-add-lead/:id", component: <AddLeads /> },
    { url: "app-update-lead/:id", component: <AddLeads /> },
    { url: "app-lead-details/:id", component: <ViewLead /> },
    { url: "app-import-leads", component: <ImportLeads /> },
    { url: "app-patients", component: <Patients /> },
    { url: "patients/add-patient", component: <AddPatients /> },
    { url: "patients/update-patient", component: <AddPatients /> },
    { url: "patients/patient-details/:id", component: <PatientsDetails /> },
    { url: "app-patient-detail", component: <ViewPatient /> },
    { url: "app-patient-details", component: <PatientsDetails /> },
    { url: "app-questionnaire", component: <Questionnaire /> },
    { url: "app-panchkarma", component: <Calendar /> },
    { url: "app-profile", component: <AppProfile /> },
    { url: "app-service-caller-reassignment", component: <ServiceCallerReassignment /> },
    /// Questionnaire
    { url: "questions", component: <Questions /> },
    { url: "add-question", component: <Question /> },
    { url: "edit-question/:id", component: <Question /> },
    { url: "forms", component: <Form /> },
    { url: "forms/create-form", component: <AddForm /> },
    { url: "forms/edit-form/:formId", component: <AddForm /> },
    // Users
    { url: "roles", component: <Role /> },
    { url: "add-role", component: <AddRole /> },
    { url: "edit-role/:id", component: <AddRole /> },
    { url: "users", component: <User /> },
    { url: "add-user", component: <AddUser /> },
    { url: "edit-user/:id", component: <AddUser /> },

    // Master

    { url: "branch", component: <Branch /> },
    { url: "add-branch", component: <AddBranch /> },
    { url: "branch/update-branch/:id", component: <AddBranch /> },

    { url: "medicine", component: <Medicine /> },
    { url: "medicine/add-medicine", component: <AddMedicine /> },
    { url: "medicine/update-medicine/:id", component: <AddMedicine /> },

    { url: "department", component: <Department /> },
    { url: "add-department", component: <AddDepartment /> },
    { url: "department/update-department/:id", component: <AddDepartment /> },

    { url: "categories", component: <Categories /> },
    { url: "categories/add-categories", component: <AddCategories /> },
    { url: "categories/update-category/:id", component: <AddCategories /> },

    { url: "symptoms", component: <Symptoms /> },
    { url: "symptoms/add-symptom", component: <AddSymptom /> },
    { url: "symptoms/update-symptom/:id", component: <AddSymptom /> },

    { url: "diseases", component: <Diseases /> },
    { url: "diseases/add-diseases", component: <AddDiseases /> },
    { url: "diseases/update-diseases/:id", component: <AddDiseases /> },

    { url: "content-bank", component: <ContentBank /> },
    { url: "add-content", component: <AddContentBank /> },

    { url: "script", component: <Script /> },
    { url: "add-script", component: <AddScript /> },
    { url: "objection", component: <Objection />},
    { url: "add-objection", component: <AddObjection />},

    { url: "default-dose", component: <DefaultDose />},
    { url: "app-add-default-dose", component: <AddDefaultDose />},

    { url: "app-unit-of-dose", component: <UnitOfDose />},
    { url: "app-add-unit-of-dose", component: <AddUnitOfDose />},
    { url: "app-anupan", component: <Anupan />},
    { url: "app-add-anupan", component: <AddAnupan />},

    { url: "app-how-to-take", component: <HowToTake />},
    { url: "add-how-to-take", component: <AddHowToTake />},
    { url: "frequency", component: <Frequency />},
    { url: "add-frequency", component: <AddFrequency />},

    { url: "campaign", component: <Campaign />},
    { url: "add-campaign", component: <AddCampaign />},

    { url: "add-note-category", component: <AddNoteCategories />},
    { url: "note-categories", component: <NoteCategories />},

    { url: "doctors", component: <Doctors /> },
    { url: "add-doctor", component: <AddDoctor /> },
    { url: "update-doctor", component: <AddDoctor /> },
    { url: "add-prescription", component: <AddPrescription /> },
    { url: "doctors-availability", component: <DoctorAvailability /> },
    { url: "disease-medicine-mapping", component: <MedicineMapping /> },
    { url: "add-medicinemapping", component: <AddMedicineMapping /> },
    { url: "symptom-medicine-mapping", component: <SymptomMedicineMapping /> },
    {
      url: "add-symptommedicinemapping",
      component: <AddSymptomMedicineMapping />,
    },
    {
      url: "assigned-history",
      component:<AssignedHistory />,
    },

    //Settings
    { url: "site-setting", component: <SiteSetting /> },
    { url: "app-patient-review-list", component: <PatientReviewList /> },
    { url: "gst", component: <GSTList /> },
    { url: "add-gst", component: <AddGST /> },
    // Panchkarma
    { url: "/therapist", component: <Therapist /> },
    { url: "karma", component: <Karma /> },
    { url: "add-karma", component: <AddKarma /> },
    { url: "/karma/update-karma/:id", component: <AddKarma /> },
    { url: "patients", component: <Patient /> },
    { url: "niyamavali", component: <Niyamavali /> },
    { url: "/add-niyamavali", component: <AddNiyamavali /> },
    { url: "/edit-niyamavali/:id", component: <AddNiyamavali /> },
    { url: "panchkarma-users", component: <PanchkarmaUsers /> },
    { url: "panchkarma-add-user", component: <AddPanchkarmaUser /> },
    { url: "panchkarma-edit-user/:id", component: <AddPanchkarmaUser /> },
    { url: "panchkarma-service-caller", component: <PanchkarmaServiceCaller /> },
    { url: "panchkarma-view-details", component: <PanchkarmaViewDetails /> },
    { url: "/panchkarma", component: <DashboardPanchkarma /> },
    // stock
    { url: "batch-QRs", component: <PrintQr /> },
    { url: "/app-create-batch-QR", component: <AddPrintQR /> },
    { ur: "stock-transactions",component: <StockTransactions />},
    { url:"/app-add-inward-stock",component:<AddInwardStock/>},
    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-customers", component: <EcomCustomers /> },

    /// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },

    /// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    /// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    /// Widget
    { url: "widget-basic", component: <Widget /> },

    /// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

    /// pages
    { url: "page-register", component: <Registration /> },
    { url: "page-lock-screen", component: <LockScreen /> },
    { url: "page-login", component: <Login /> },

    { url: "page-error-400", component: <Error400 /> },
    { url: "page-error-403", component: <Error403 /> },
    { url: "page-error-404", component: <Error404 /> },
    { url: "page-error-500", component: <Error500 /> },
    { url: "page-error-503", component: <Error503 /> },
    { url: "todo", component: <Todo /> },
    // ForgetPassword
    { url: "app-forget-password", component: <AppForgetPassword /> },
    { url: "app-change-password", component: <ChangePassword /> },
    { url: "case-paper/:patientId?", component: <CasePaper /> },
    { url: "token-system", component: <TokenSystem /> },
    { url: "token-system-multi", component: <TokenSystemMulti /> },
    { url: "register-yourself", component: <RegisterYourSelf /> },
    {
      url: "appointment-calendar-test",
      component: <AppointmentCalendarTest />,
    },
    { url: "appointments", component: <AssignedAppointment /> },
  {url:"pathyas", component:<Pathyas />},
  {url:"add-pathyas", component:<AddPathyas />},
  {url:"otp-verification", component:<OTPVerification />},
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />

        <Route
          path="/forms/patient-form/:formId/:patientId"
          element={<PatientFormWrapper />}
        />
        <Route
          path="/patient/:patientId/menopause-form"
          element={<MenopauseFormPage />}
        />
        <Route
          path="/patient/:patientId/gapld-form"
          element={<GapldFormPage />}
        />
        <Route
          path="/patient/:patientId/male-form"
          element={<MaleFormPage />}
        />
        <Route
          path="/forms/patient-form/:formId"
          element={<PatientForm />}
          exact
        />
        {/* <Route path="/patient-access/:id" element={<OTPVerificationPage />} /> */}
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const sideMenu = useSelector((state) => state.sideMenu);
  const dispatch = useDispatch();

  console.log("MainLayout - sideMenu state:", sideMenu);
  console.log(
    "MainLayout - menu-toggle class will be:",
    sideMenu ? "menu-toggle" : ""
  );

  // Reset menu state when MainLayout component mounts
  useEffect(() => {
    console.log("MainLayout - component mounted, resetting menu state");
    dispatch(resetMenu());
  }, [dispatch]);

  return (
    <div id="main-wrapper" className={`show ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 15 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Markup;
